export default __webpack_public_path__ + "static/media/create-event.3b0ce492.svg";